/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { isEqual } from 'lodash';
import hwaxios from '../../../rmsReduxStore/api-service/HWAxios';
import rmsStore from '../../../rmsReduxStore/rmsStore';
import { acDashboardTypes } from '../acReduxExports';
const baseUrl = process.env.REACT_APP_SERVER_BASE_URL_AC;


export const setDashboardHeaderLoader:any =
  (val: boolean) =>
    async (
      dispatch: (action: Partial<AcDashboardAction>) => void
    ): Promise<void> => {
      const loaderAction: Partial<AcDashboardAction> = {
        type: acDashboardTypes.SET_AC_DASHBOARD_STATE_DATA,
        dashboardHeaderLoader: val,
      };
      dispatch(loaderAction);
    };


    export const fetchNewAcDashboardHeaderData:any =
   (reqBody) =>
    async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
      const url =  baseUrl + '/newDashboard';
      // dispatch({
      //   type: dashboardTypes.FETCH_NEW_DASHBOARD_HEADER_DATA,
      //   newDashboardHeaderData: null,
      // });

      const reqFilterHash = reqBody?.filters || {};
      const hashAction: Partial<AcDashboardAction> = {
        type: acDashboardTypes.SET_NEW_AC_DASHBOARD_HEADER_FILTER_HASH,
        newDashboardHeaderFilterHsah: reqFilterHash,
      }
      dispatch(hashAction);
      try {
        setDashboardHeaderLoader(true);

        const response = await hwaxios.post(url, reqBody);
      
          const action: Partial<AcDashboardAction> = {
            type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_HEADER_DATA,
            newDashboardHeaderData: response?.data,
          };
          dispatch(action);

      } catch (error) {
        setDashboardHeaderLoader(false);
        console.error(error);

        throw error;
      }
    };


    export const fetchNewAcDashboardAlarmSummaryList :any = (reqBody: any) =>
  async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/alarm/alarm-list';

    try {
      const loaderStartAction: Partial<AcDashboardAction> = {
        type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_ALARM_SUMMARY_TABLE_LOADER,
        newDashboardAlarmSummaryTableLoader: true
      }
      dispatch(loaderStartAction);

      const reqFilterHash = reqBody?.filters || {};
      const hashAction: Partial<AcDashboardAction> = {
        type: acDashboardTypes.SET_AC_NEW_DASHBOARD_ALARM_SUMMARY_FILTER_HASH,
        newDashboardAlarmSummaryFilterHash: reqFilterHash,
      }
      dispatch(hashAction);

      const response = await hwaxios.post(url, reqBody);
      
    
        const action: Partial<AcDashboardAction> = {
          type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_ALARM_SUMMARY_LIST,
          newDashboardAlarmSummaryInfo: response.data?.data?.alarms,
        };
        dispatch(action);
      
      
      const loaderEndAction: Partial<AcDashboardAction> = {
        type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_ALARM_SUMMARY_TABLE_LOADER,
        newDashboardAlarmSummaryTableLoader: false
      }
      dispatch(loaderEndAction);
      
      return response.data;
    } catch (error) {
      console.error(error);

      const loaderEndAction: Partial<AcDashboardAction> = {
        type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_ALARM_SUMMARY_TABLE_LOADER,
        newDashboardAlarmSummaryTableLoader: false
      }
      dispatch(loaderEndAction);
      throw error;
    }
  };


    export const fetchNewAcDashboardRealTimeGunInfo:any =
    (reqBody) =>
     async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
       const url =  baseUrl + '/newDashboard/real-time-utilization-info';
      //  dispatch({
      //   type: dashboardTypes.FETCH_NEW_DASHBOARD_REAL_TIME_GUN_INFO,
      //   newDashboardRealTimeGunsInfo: null,
      // });

      const reqFilterHash = reqBody?.filters || {};
      const hashAction: Partial<AcDashboardAction> = {
        type: acDashboardTypes.SET_AC_NEW_DASHBOARD_REALTIME_GUN_INFO_FILTER_HASH,
        newDashboardRealtimeGunInfoFilterHash: reqFilterHash,
      }
      dispatch(hashAction);
       try {
         setDashboardHeaderLoader(true);
 
         const response = await hwaxios.post(url, reqBody);
 
       
          const action: Partial<AcDashboardAction> = {
            type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_REAL_TIME_GUN_INFO,
            newDashboardRealTimeGunsInfo: response?.data,
          };
          dispatch(action);
         
       } catch (error) {
         setDashboardHeaderLoader(false);
         console.error(error);
 
         throw error;
       }
    };

  export const fetchNewAcDashboardChargingSessionsList :any = (reqBody) =>
    async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
      const url =  baseUrl + '/newDashboard/charging-session-data';
      // dispatch({
      //   type: dashboardTypes.FETCH_NEW_CHARGING_SESSIONS_INFO,
      //   newDashboardChargingSessionsInfo: null,
      //   newDashboardChargingSessionsStats: null
      // });

      const reqFilterHash = reqBody?.filters || {};
      const hashAction: Partial<AcDashboardAction> = {
        type: acDashboardTypes.SET_NEW_DASHBOARD_AC_CHARGING_SESSION_FILTER_HASH,
        newDashboardChargingSessionFilterHash: reqFilterHash,
      }
      dispatch(hashAction);
      
      try {
        const response = await hwaxios.post(url, reqBody);
        

          const action: Partial<AcDashboardAction> = {
            type: acDashboardTypes.FETCH_NEW_AC_CHARGING_SESSIONS_INFO,
            newDashboardChargingSessionsInfo: response.data?.data,
            newDashboardChargingSessionsStats: response.data?.stats
          };
          dispatch(action);
        
        
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };


const setCustomerWiseChargerHealthGraphLoader =
  (val) =>
    async (dispatch): Promise<void> => {
      const loaderSuccessAction: Partial< AcDashboardAction> = {
        type: acDashboardTypes.SET_AC_DASHBOARD_STATE_DATA,
        customerWiseChargerHealthGraphLoader: val,
      };
      dispatch(loaderSuccessAction);
    };


export const fetchNewDashboardAcConnectivityMediumData:any =
     (reqBody) =>
       async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
         const url = baseUrl + '/newDashboard/charger-by-connectivity';
        //  dispatch({
        //   type: dashboardTypes.FETCH_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_DATA,
        //   newDashboardConnectivityMediumData: null,
        // });

        const reqFilterHash = reqBody?.filters || {};
        const hashAction: Partial<AcDashboardAction> = {
          type: acDashboardTypes.SET_NEW_AC_DASHBOARD_CONNECTIVITY_MEDIUM_FILTER_HASH,
          newDashboardConnectivityFilterHash: reqFilterHash,
        }
        dispatch(hashAction);
         try {
           setCustomerWiseChargerHealthGraphLoader(true);
           const response = await hwaxios.post(url, reqBody);
            const action: Partial<AcDashboardAction> = {
              type: acDashboardTypes.FETCH_NEW_AC_DASHBOARD_CONNECTIVITY_MEDIUM_DATA,
              newDashboardConnectivityMediumData: response.data?.data,
            };
            dispatch(action);
           setCustomerWiseChargerHealthGraphLoader(true);
           return response.data;
         } catch (error) {
           console.error(error);
           setCustomerWiseChargerHealthGraphLoader(true);
           throw error;
         }
       };

    export const fetchNewDashboardAcChargingSessionTrendList :any = (reqBody) =>
      async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
        const url = baseUrl + '/newDashboard/charging-session-time';
        // dispatch({
        //   type: dashboardTypes.FETCH_NEW_DASHBOARD_CHARGING_SESSION_TRENDS_INFO,
        //   newDashboardChargingSessionTrendInfo: null,
        // });

        const reqFilterHash = reqBody?.filters || {};
        const hashAction: Partial<AcDashboardAction> = {
          type: acDashboardTypes.SET_AC_CHARGING_SESSION_TREND_FILTER_HASH,
          newDashboardCharginsSessionTrendFilterHash: reqFilterHash,
        }
        dispatch(hashAction);
        try {
          const response = await hwaxios.post(url, reqBody);
            const action: Partial<AcDashboardAction> = {
              type: acDashboardTypes.FETCH_NEW_AC_DASHBOARD_CHARGING_SESSION_TRENDS_INFO,
              newDashboardChargingSessionTrendInfo: response.data?.data,
            };
            dispatch(action);
          return response.data;
        } catch (error) {
          console.error(error);
          throw error;
        }
      };


        export const fetchNewDashboardAcEnergyTrendList :any = (reqBody) =>
          async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
            const url = baseUrl + '/newDashboard/energy-consumption-trend'; 
            // dispatch({
            //   type: dashboardTypes.FETCH_NEW_DASHBOARD_ENERGY_TREND_INFO,
            //   newDashboardEnergyTrendInfo: null,
            // });
            const reqFilterHash = reqBody?.filters || {};
            const hashAction: Partial<AcDashboardAction> = {
              type: acDashboardTypes.SET_NEW_AC_DASHDOARD_ENERGY_TREND_FILTER_HASH,
              newDashboardEnergyTrendFilterHash: reqFilterHash,
            }
            dispatch(hashAction);
            try {
              const response = await hwaxios.post(url, reqBody);
              

                const action: Partial<AcDashboardAction> = {
                  type: acDashboardTypes.FETCH_NEW_AC_DASHBOARD_ENERGY_TREND_INFO,
                  newDashboardEnergyTrendInfo: response.data?.data,
                };
                dispatch(action);
              return response.data;
            } catch (error) {
              console.error(error);
              throw error;
            }
          };

      export const fetchNewAcDashboardAttentionRequiredList :any = (reqBody) =>
        async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
          const url = baseUrl + '/newDashboard/attention-required-chargers';

          dispatch({
            type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_ATTENTION_REQUIRED_DATA,
            newDashboardAttentionRequiredInfo: null,
          });

          const reqFilterHash = reqBody?.filters || {};
          const hashAction: Partial<AcDashboardAction> = {
            type: acDashboardTypes.SET_AC_ATTENTION_REQUIRED_FILTER_HASH,
            newDashboardAttentionRequiredFilterHash: reqFilterHash,
          };
          dispatch(hashAction);
          try {
            const response = await hwaxios.post(url, reqBody);
            if (isEqual(reqFilterHash, rmsStore.getState().acdashboardReducer?.newDashboardAttentionRequiredFilterHash)) {
              const action: Partial<AcDashboardAction> = {
                type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_ATTENTION_REQUIRED_DATA,
                newDashboardAttentionRequiredInfo: response.data?.data,
              };
              dispatch(action);
            }
            return response.data;
          } catch (error) {
            console.error(error);
            throw error;
          }
        };

      export const fetchNewDashboardAcChargingVsIdleList :any = (reqBody) =>
        async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
          const url = baseUrl + '/newDashboard/idle-charging-time';
          // dispatch({
          //   type: dashboardTypes.FETCH_NEW_DASHBOARD_CHARGING_VS_IDLE_INFO,
          //   newDashboardChargingVsIdleInfo: null,
          // });

          const reqFilterHash = reqBody?.filters || {};
          const hashAction: Partial<AcDashboardAction> = {
            type: acDashboardTypes.SET_AC_DASHBOARD_CHARGING_VS_IDLE_FILTER_HASH,
            newDashboardChargingVsIdleFilterHash: reqFilterHash,
          }
          dispatch(hashAction);
          try {
            const response = await hwaxios.post(url, reqBody);


              const action: Partial<AcDashboardAction> = {
                type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_CHARGING_VS_IDLE_INFO,
                newDashboardChargingVsIdleInfo: response.data?.data,
              };
              dispatch(action);
            
            return response.data;
          } catch (error) {
            console.error(error);
            throw error;
          }
        };

export const fetchNewDashboardAcOverallUptimeList: any = (reqBody) =>
  async (dispatch: (arg0: Partial<AcDashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/newDashboard/chargers-uptime';

    const reqFilterHash = reqBody?.filters || {};
    const hashAction: Partial<AcDashboardAction> = {
      type: acDashboardTypes.SET_AC_DASHBOARD_OVERALL_UPTIME_FILTER_HASH,
      newDashboardOverallUptimeFilterHash: reqFilterHash,
    }
    dispatch(hashAction);
    try {
      const response = await hwaxios.post(url, reqBody);

      // Ignore the response if the filters were changed while this request was in flight
      if (isEqual(reqFilterHash, rmsStore.getState().acdashboardReducer?.newDashboardOverallUptimeFilterHash)) {
        const action: Partial<AcDashboardAction> = {
          type: acDashboardTypes.FETCH_AC_NEW_DASHBOARD_OVERALL_UPTIME_INFO,
          newDashboardOverallUptimeInfo: response.data?.data,
        };
        dispatch(action);
      }
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
